import { styled } from '@ori-ui/mui';
// Wrapper component to change background color and add styles for legacy icons.
export const SupportCenterRoot = styled('div')((param)=>{
    let { theme } = param;
    return {
        background: theme.palette.grey[100],
        // Can be removed after redesign.
        // This equals to '[class*=v-icon-]'
        vIcon: {
            fontSmooth: 'always',
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            textRendering: 'optimizeSpeed'
        },
        // Can be removed after redesign.
        '.dl-message:before, .dl-navigation>li:first-child>a:after, .dl-warning:before, .error-icon:before, .icon-arrow:before, .k-edit:before, .k-filter:before, .k-update:before, .k-warning:before, .rsArrowIcn:before, .shipping-offer:before, .success-icon:before, .title-icon:before, .toggle:after, .ui-accordion .expanded.toggle:before, .ui-brand-megamenu .trigger:after, .ui-brand-navbar .dropdown .brand-label:after, .ui-digital-catalogue .product-slider-nav .next:before, .ui-digital-catalogue .product-slider-nav .prev:before, .ui-facet-navigation .right-arrow:after, .ui-filter-bar .filter-box .heading.expanded:before, .ui-new-filter-bar .filtered-item:before, .ui-shades-box .opened .toggle:before, .with-icon:before, [class*=icon-] a:after, [class*=k-i-]:before, [class*=v-after-icon-]:after, [class*=v-icon-]:before': {
            display: 'inline-block',
            fontFamily: 'IconsOri',
            fontWeight: '400',
            textDecoration: 'none',
            textTransform: 'none'
        }
    };
});
